/**
 * Constants for dispatch management
 */

export const EMPLOYEE_TYPES = ["manager", "housekeeping", "maintenance", "frontDesk"];

export const TASK_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled"
};

export const COMMON_LOCATIONS = {
  LOBBY: "lobby",
  HALLWAY: "hallway",
  GROUNDS: "grounds",
  ALL_BUILDINGS: "All Buildings"
};

export const BASE_TASK_TYPES = [
  {
    id: 1,
    task: "Porter",
    taskType: ["housekeeping", "maintenance"],
    taskLocations: [COMMON_LOCATIONS.LOBBY, COMMON_LOCATIONS.HALLWAY, COMMON_LOCATIONS.GROUNDS],
  },
  {
    id: 2,
    task: "Room Turn",
    taskType: ["housekeeping", "maintenance"],
    taskLocations: [], // Will be populated dynamically with rooms
  },
  {
    id: 3,
    task: "Work Orders",
    taskType: ["maintenance"],
    taskLocations: [], // Will be populated dynamically with buildings
  },
  {
    id: 4,
    task: "Lunch",
    taskType: EMPLOYEE_TYPES,
    taskLocations: [COMMON_LOCATIONS.LOBBY]
  },
  {
    id: 5,
    task: "Break",
    taskType: EMPLOYEE_TYPES,
    taskLocations: [COMMON_LOCATIONS.LOBBY]
  },
  {
    id: 6,
    task: "Meeting",
    taskType: EMPLOYEE_TYPES,
    taskLocations: [COMMON_LOCATIONS.LOBBY],
  },
  {
    id: 7,
    task: "Training",
    taskType: EMPLOYEE_TYPES,
    taskLocations: [COMMON_LOCATIONS.LOBBY],
  },
  {
    id: 8,
    task: "Other",
    taskType: EMPLOYEE_TYPES,
    taskLocations: []
  },
];

export const DEFAULT_DISPATCH_ITEM = {
  startTime: "",
  endTime: "",
  task: "",
  location: "",
  notes: "",
  status: TASK_STATUS.PENDING,
  completed: false,
};